import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {
    show_screener: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/screener";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    show_survey: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/survey";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    create_response: async (surveyData, missionId, surveyId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/survey_responses/" + surveyId;

        const body = JSON.stringify({
            survey_response: surveyData
        })


        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                body: body,
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },


}